import React, { Component } from 'react';
import { authContext } from '../adalConfig';
import axios from 'axios';
import './react-datetime.css';
import 'react-table/react-table.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import './MonthlyView.css';
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from './csvSanitizer';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import * as appsettings from './constants';
export class MonthlySummary extends Component {
    displayName = MonthlySummary.name
    constructor(props) {
        super(props);
        this.state = {
            TempData: [], datatobeshown: appsettings.datatobeshown[0],
            month: 0, year: 0,
            greenFont: appsettings.ReliabilityGreenTarget,
            Columns: [], Metric: [],
            metricType: appsettings.metricTypes[0],
            environment: appsettings.options[0],
            loading: false
        };
    }
    componentDidMount() {
        this.getLatestMonth();
        this.getData(this.state.metricType.value, this.state.environment.value);
        var user = authContext.getCachedUser();
        var userId = user.userName;
        var domainIndex = userId.indexOf('@microsoft.com');
        userId = userId.substr(0, domainIndex);
        this.setState({
            userId: userId
        })
    }
    getData(metric, environment) {
        this.setState({
            loading: true
        });
        var apilink = "api/CosmosApi/GetMonthlySummary/?metricType=" + metric + "&environment=" + environment;
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Metric: response.data,
                TempData: response.data
            });
        });

    }
    onSelectDataToBeShown(event) {
        if (event.value === 'All') {
            this.setState({
                Metric: this.state.TempData
            })
        }
        else {
            var datatobedisplayed = [];
            for (var i = 0; i < this.state.Metric.length; i++) {
                if (
                    (this.state.Metric[i].data1 < this.state.greenFont && this.state.Metric[i].data1 > 0) ||
                    (this.state.Metric[i].data2 < this.state.greenFont && this.state.Metric[i].data2 > 0) ||
                    (this.state.Metric[i].data3 < this.state.greenFont && this.state.Metric[i].data3 > 0) ||
                    (this.state.Metric[i].data4 < this.state.greenFont && this.state.Metric[i].data4 > 0) ||
                    (this.state.Metric[i].data5 < this.state.greenFont && this.state.Metric[i].data5 > 0) ||
                    (this.state.Metric[i].data6 < this.state.greenFont && this.state.Metric[i].data6 > 0)
                )
                    datatobedisplayed.push(this.state.Metric[i]);
            }
            this.setState({
                Metric: datatobedisplayed
            })
        }
    }
    getLatestMonth() {

        var apilink = "api/CosmosApi/GetLatestMonth/";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                month: response.data[0],
                year: response.data[1]
            });
        });

    }
    onSelectEnvironment(event) {
        this.setState({
            environment: event
        });
        this.getData(this.state.metricType.value, event.value);
    }
    onSelectmetricType(event) {
        this.setState({
            metricType: event
        });
        this.getData(event.value, this.state.environment.value);

        if (event.value === "Performance") {
            this.setState({
                greenFont: appsettings.PerformanceGreenTarget
            });
        }
        else if (event.value === "Availability") {
            this.setState({
                greenFont: appsettings.AvailabilityGreenTarget
            });
        }
        else {
            this.setState({
                greenFont: appsettings.ReliabilityGreenTarget
            });
        }
    }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {
        var Months = appsettings.Months;
        var selectedMonths = ['', '', '', '', '', ''];
        for (var j = 0; j < 6; j++) {
            var month = this.state.month - j - 1;
            var year = this.state.year;
            if (month < 0) {
                month = (month + 12) % 12;
                year = year - 1;
            }
            selectedMonths[j] = Months[month] + " " + year;
        }
        var columns = [
            { Header: 'Team', accessor: 'TeamName', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontWeight: 'bold' } } } },
            { Header: selectedMonths[0], accessor: 'data6', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data6 >= this.state.greenFont ? "green" : rowInfo.row.data6 > 0 ? "red" : "white" } }; } },
            { Header: selectedMonths[1], accessor: 'data5', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data5 >= this.state.greenFont ? "green" : rowInfo.row.data5 > 0 ? "red" : "white" } }; } },
            { Header: selectedMonths[2], accessor: 'data4', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data4 >= this.state.greenFont ? "green" : rowInfo.row.data4 > 0 ? "red" : "white" } }; } },
            { Header: selectedMonths[3], accessor: 'data3', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data3 >= this.state.greenFont ? "green" : rowInfo.row.data3 > 0 ? "red" : "white" } }; } },
            { Header: selectedMonths[4], accessor: 'data2', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data2 >= this.state.greenFont ? "green" : rowInfo.row.data2 > 0 ? "red" : "white" } }; } },
            { Header: selectedMonths[5], accessor: 'data1', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data1 >= this.state.greenFont ? "green" : rowInfo.row.data1 > 0 ? "red" : "white" } }; } },
        ];

        var csvHeaders = [
            { label: appsettings.DSMService, key: 'TeamName' },
            { label: selectedMonths[0], key: 'data6' },
            { label: selectedMonths[1], key: 'data5' },
            { label: selectedMonths[2], key: 'data4' },
            { label: selectedMonths[3], key: 'data3' },
            { label: selectedMonths[4], key: 'data2' },
            { label: selectedMonths[5], key: 'data1' }
        ]
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.MonthlySummaryHeader}</h4>
                </div>
                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <div id='EnvTitle'>Environment:</div>
                    <Dropdown className='Environment' options={appsettings.options} onChange={this.onSelectEnvironment.bind(this)} value={this.state.environment} placeholder="Select an option" />
                    <div id='starttime'>Metric Type:</div>
                    <Dropdown className='metricType' options={appsettings.metricTypes} onChange={this.onSelectmetricType.bind(this)} value={this.state.metricType} placeholder="Select an option" />
                    <div id='EnvTitle' style={{ marginLeft: '10px' }}>Display:</div>
                    <Dropdown className='datatobedisplayed' options={appsettings.datatobeshown} onChange={this.onSelectDataToBeShown.bind(this)} value={this.state.datatobeshown} placeholder="Select an option" />
                    <CSVLink data={sanitizeCsvData(this.state.Metric)} filename={"CSTelemetry.csv"} headers={csvHeaders} className="csvExport">Export to csv</CSVLink>
                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                        style={{ marginLeft: '10px' }}
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />

                <p id='target'>Target : Availability: >={appsettings.AvailabilityGreenTarget}%, Reliability:>={appsettings.ReliabilityGreenTarget}%, Performance: >={appsettings.PerformanceGreenTarget}%  </p>
                <ReactTable
                    data={this.state.Metric}
                    columns={columns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.state.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '1px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap',
                                background: rowInfo.index === this.state.selected ? '#96B1C7' : ''
                            },
                        };
                    }}
                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '14px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}
                />
            </div>
        );
    }
}
